const translations = {
  nav_about: "概要",
  nav_activities: "活動内容",
  nav_vision: "ビジョン",
  nav_join: "参加する",
  lang_en: "EN",
  lang_ja: "JP",

  hero_label: "企業を超えてつながり、新たな機会を生み出す",
  hero_title_line1: "NJ-Japan Business Hub",
  hero_title_line2: "日系ビジネスパーソンのためのコミュニティ",
  hero_subtitle: "NJの日系企業で働くビジネスパーソンのためのコミュニティ",
  hero_cta: "コミュニティに参加する",
  hero_scroll: "詳しく見る",

  bg_label: "背景・課題",
  bg_title: "多くの方が感じていること",
  bg_text1: "ニュージャージー州には、多くの日系企業が拠点を構えています。一方で、ニューヨークやロサンゼルスのように、企業や業界を横断したつながりを持つ機会は、まだ限られているのが現状です。",
  bg_text2: "同じ地域で働いていても、他社の方と交流する機会がほとんどない。",
  bg_question: "日々の業務の中で、ふとそのように感じたことはありませんか。",

  community_label: "コミュニティについて",
  community_title: "企業の壁を越えた、つながりの場",
  community_text: "本コミュニティは、ニュージャージーに拠点を置く日系企業で働く方々が、企業・職種・国籍を超えてつながることを目的としたコミュニティです。特定の業界や職種に限定することなく、同じ地域で働くビジネスパーソン同士が、自然に交流し、関係性を築く場を目指しています。",

  value_label: "提供価値",
  value_title: "このコミュニティで得られること",
  value_item1_title: "他社とのネットワーキング",
  value_item1_text: "同じ地域の他の日系企業で働く方々とつながり、プロフェッショナルなネットワークを広げることができます。",
  value_item2_title: "経験・課題の共有",
  value_item2_text: "日系企業ならではの課題や経験を共有し、共通の視点を持つ仲間と深く語り合うことができます。",
  value_item3_title: "新たな気づき",
  value_item3_text: "日々の業務では得られない視点や情報を、ディスカッションや意見交換を通じて得ることができます。",
  value_item4_title: "ビジネス・キャリアの機会",
  value_item4_text: "人とのつながりを通じて、新たなビジネスやキャリアのきっかけを見つけることができます。",

  activities_label: "活動内容",
  activities_title: "つながるための場づくり",
  activities_item1_title: "定期ミートアップ",
  activities_item1_text: "対面またはオンラインで定期的に集まり、リラックスした雰囲気の中で交流します。",
  activities_item2_title: "少人数ディスカッション",
  activities_item2_text: "少人数のグループで、テーマを絞った対話を通じて深い議論を行います。",
  activities_item3_title: "オンラインコミュニティ",
  activities_item3_text: "Slackを活用した継続的な情報交換と交流の場を提供しています。",
  activities_note: "形式にとらわれず、参加者同士が自然に会話し、継続的な関係性を築ける場を大切にしていきます。",

  vision_label: "ビジョン",
  vision_title: "長期的なつながりを、ここから",
  vision_text1: "まずは、ニュージャージーにおける日系ビジネスパーソン同士のつながりを築くことから始めます。",
  vision_text2: "その上で、将来的には、情報共有や協働を通じて、ビジネスの成長や新たな機会創出につながるコミュニティへと発展していくことを目指しています。",

  organizer_label: "運営者",
  organizer_title: "Cornerstone Strategy LLC が企画・運営",
  organizer_text: "Cornerstone Strategyは、米国に進出する、または既に展開している日系企業に対して、コーチングおよび人事コンサルティングを通じて、組織・人材の成長を支援しています。",
  organizer_founder_label: "Founder & CEO",
  organizer_founder_name: "清野 真輔",
  organizer_founder_bio: "アクセンチュア、デロイト トーマツ コンサルティング等にて、組織・人材領域を中心に多数のプロジェクトに従事。現在はニュージャージーにて、日系企業のグローバル展開を支援しています。",
  organizer_mission: "本取り組みは、同じ地域で働く方々のつながりを起点に、価値ある関係性と機会を生み出すことを目的としています。",

  cta_label: "参加募集",
  cta_title: "メンバーとして参加しませんか",
  cta_text: "本コミュニティは、ニュージャージーで日系企業に従事するビジネスパーソンが、組織や職種を越えてつながり、交流するためのオープンなプラットフォームです。ご関心のある方はどなたでも歓迎します。現在、参加費は無料です。コミュニティの成長に伴い、詳細は変更される場合があります。",
  cta_subtitle: "コミュニティに参加しましょう。",
  cta_form_name: "お名前",
  cta_form_email: "メールアドレス",
  cta_form_company: "会社名",
  cta_form_role: "役職・職種",
  cta_form_message: "メッセージ（任意）",
  cta_form_message_placeholder: "ご興味のあること、ご質問、このコミュニティに期待することなど、自由にご記入ください。",
  cta_form_link_desc: "下記ボタンより、オンラインフォームから登録をお願いします。",
  cta_form_submit: "登録する",
  cta_form_success: "ありがとうございます！近日中にご連絡いたします。",
  cta_form_error: "エラーが発生しました。もう一度お試しください。",
  cta_form_char_limit: "最大500文字",

  footer_tagline: "コーチング＆コンサルティング",
  footer_copyright: "© 2026 Cornerstone Strategy LLC. All rights reserved.",
  footer_contact: "お問い合わせ",
  footer_website: "Cornerstone Strategy サイトへ",
  footer_privacy: "プライバシーポリシー",
  footer_terms: "利用規約",
};

export default translations;
